module.exports = __webpack_public_path__ + "img/user-guide-02-04-02.dce20ff9.png";